<template>
       <div class="container">
             <header class="page-header">
                    <ol class="breadcrumb page-breadcrumb">
                        <li>
                            <router-link :to="{ name: 'home'}">Home</router-link>
                        </li>
                        <li class="active">All categories</li>
                    </ol>
            </header>
            <div class="row">
                <div class="col-md-9">
                    <div class="row" data-gutter="15">
                        <div class="col-md-12">
                            <div class="product product-left ">
                            <div class="row">
                                <div class="col-md-12">
                                    <h5 class="dropdown-menu-category-title-allcat">Products by Category</h5>
                                        <ul class="col-md-4 dropdown-menu-category-list">
                                            <li v-for="category in productsFirstColumn">
                                                <router-link :to="{ name: 'productsByCategory', params: { id: category.CategoryId }}">{{category.CategoryName}}</router-link>
                                                <p>{{category.ShortDescription}}</p>
                                            </li>
                                        </ul>
                                        <ul class="col-md-4 dropdown-menu-category-list">
                                            <li v-for="category in productsSecondColumn">
                                                 <router-link :to="{ name: 'productsByCategory', params: { id: category.CategoryId }}">{{category.CategoryName}}</router-link>
                                                <p>{{category.ShortDescription}}</p>
                                            </li>
                                        </ul>
                                        <ul class="col-md-4 dropdown-menu-category-list">
                                            <li v-for="category in productsThirdColumn">
                                                 <router-link :to="{ name: 'productsByCategory', params: { id: category.CategoryId }}">{{category.CategoryName}}</router-link>
                                                <p>{{category.ShortDescription}}</p>
                                            </li>
                                        </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" data-gutter="15">
                        <div class="col-md-12">
                            <div class="product product-left ">
                            <div class="row">
                                <div class="col-md-12">
                                    <h5 class="dropdown-menu-category-title-allcat">Services by Category</h5>
                                        <ul class="col-md-4 dropdown-menu-category-list">
                                            <li v-for="category in servicesFirstColumn">
                                                 <router-link :to="{ name: 'servicesByCategory', params: { id: category.CategoryId }}">{{category.CategoryName}}</router-link>
                                                <p>{{category.ShortDescription}}</p>
                                            </li>                                                                              
                                        </ul>
                                        <ul class="col-md-4 dropdown-menu-category-list">
                                            <li v-for="category in servicesSecondColumn">
                                                 <router-link :to="{ name: 'servicesByCategory', params: { id: category.CategoryId }}">{{category.CategoryName}}</router-link>
                                                <p>{{category.ShortDescription}}</p>
                                            </li>                                                                                 
                                        </ul>
                                        <ul class="col-md-4 dropdown-menu-category-list">
                                            <li v-for="category in servicesThirdColumn">
                                                 <router-link :to="{ name: 'servicesByCategory', params: { id: category.CategoryId }}">{{category.CategoryName}}</router-link>
                                                <p>{{category.ShortDescription}}</p>
                                            </li>                                                                                         
                                        </ul>                                                                              
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <LatestTendersRfq></LatestTendersRfq>
            </div>
        </div>
</template>

<script>

import { mapState } from 'vuex'
import stringHelper from '../lib/stringHelper'
import LatestTendersRfq from '@/components/LatestTendersRfq'

export default {
    components:{
        LatestTendersRfq
    },
    data() {
        return {
            productsFirstColumn: [],
            productsSecondColumn: [],
            productsThirdColumn: [],
            servicesFirstColumn: [],
            servicesSecondColumn: [],
            servicesThirdColumn: []
        };
    },
    created() {
        this.$store.dispatch('categories/fetchRfqTenderList')
        this.$store.dispatch('categories/fetchAllCategories')
        .then(()=> {
            var index = 0;
            while (index != this.allProductCategories.length) {
                this.productsFirstColumn.push(this.allProductCategories[index]);
                index++;
                if (index == this.allProductCategories.length) {
                    break;
                }
                this.productsSecondColumn.push(this.allProductCategories[index]);
                index++;
                if (index == this.allProductCategories.length) {
                    break;
                }
                this.productsThirdColumn.push(this.allProductCategories[index]);
                index++;
            }
            index = 0;
            while (index != this.allServiceCategories.length) {
                this.servicesFirstColumn.push(this.allServiceCategories[index]);
                index++;
                if (index == this.allServiceCategories.length) {
                    break;
                }
                this.servicesSecondColumn.push(this.allServiceCategories[index]);
                index++;
                if (index == this.allServiceCategories.length) {
                    break;
                }
                this.servicesThirdColumn.push(this.allServiceCategories[index]);
                index++;
            }
        })
    },
	computed: {
		...mapState('categories', [
            'allProductCategories',
            'allServiceCategories',
            'rfq',
            'tenders'
        ])
    },
    methods: {
        formatDate(date) {
            return stringHelper.formatDate(date);
        }
    }
}
</script>

